export default __webpack_public_path__ + "img/sidebars-2-2c5a9517.png";